export const initialState = {
  stack: [],
}
